export const UIActionType = {
  UPDATE_HEADER_THEME: 'HEADER.UPDATE_HEADER_THEME'
}